export const getPrevNextRouteObject = (slug: string) => {
  const route = useRoute()
  return {
    name: getRouteName(),
    params: { slug },
    query: route.query,
  }
}
